import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../../src/auth/useAuth';
import AuthSettingsItem from '../authSettings/AuthSettingsItem';

const SettingsPrivacy = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!user) return <></>;
  return (
    <div className='flex w-full flex-col items-center justify-start gap-8 rounded-2xl bg-white p-8 shadow-md'>
      <h3 className='text-blue-primary mb-3 w-full text-2xl font-bold'>Sécurité et confidentialité</h3>
      <AuthSettingsItem
        title='Authentification à double facteur'
        description='Recevez un code par SMS à chaque connexion afin de renforcer la sécurité de votre compte.'
        fieldType='ACTIVATE'
        actionDate={user?.oneTimePasswordActivedAt}
        borderBottom
        actionOnClick={() => navigate(`/dashboard/settings/privacy/doubleAuthentication`)}
      />
      <AuthSettingsItem
        title='Supprimer le compte'
        description='Supprimez définitivement votre compte et vos données associées, conformément à notre politique de confidentialité.'
        fieldType='INFO'
        actionOnClick={() => navigate(`/dashboard/settings/privacy/deleteAccount`)}
      />
    </div>
  );
};

export default SettingsPrivacy;
